/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: DynamicSection.tsx
 * Project: mle-client-n
 * Committed last: 2022/6/14 @ 854
 * ---
 * Description:
 */

import {useEffect, useState} from 'react';
import {DataRefType, IDynamicDataRef} from '@revodigital/mpes';
import {splitPerDataOriginId} from '../../../common/datarefs';
import {mleDomainGqlClient} from '../../../api/domain';
import {mlAuthSecured} from '../../../store/features/mylabel/auth/MyLabelAuthFeature';
import {COMPUTE_DY_FIELDS} from '../../../api/domain/queries.gql';
import {OriginTypeSection, RefData} from './OriginTypeSection';
import {HasEditor} from '../../../common/props';
import {observer} from 'mobx-react';
import {Button, Intent} from '@blueprintjs/core';
import {DataOriginComputeResult} from "../../../entities";

interface Props extends HasEditor {
    onLinkField: () => void;
}

export const DynamicSection = observer((props: Props) => {
    const [refData, setRefData] = useState<RefData[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
            (async () => {
                setIsLoading(true);
                // Fields list
                const fields = props.editor.dataOriginFeature.dataRefs.filter(it => it.type === DataRefType.DYNAMIC);

                // Dividere per id (tutti quelli con lo stesso)
                const idGroups = splitPerDataOriginId(fields as IDynamicDataRef[]);
                let result: RefData[] = [];

                // Per ogni gruppo, ottenere l'origine dati relativa
                for (const idGroup of idGroups) {
                    // Get all keys list
                    const keys: string[] = idGroup.refs.map(it => it.fieldName).filter(it => it.length > 0);

                    const values = await (mlAuthSecured<DataOriginComputeResult[]>(props.editor, async () => {
                        return (await mleDomainGqlClient.mutate({
                            mutation: COMPUTE_DY_FIELDS,
                            variables: {
                                revisionId: props.editor.recipeSwitcher.activeRevision,
                                companyId: props.editor.recipeSwitcher.activeCompany,
                                keys: keys
                            }
                        })).data.computeDynamicOriginValues
                    }));

                    if (values) {
                        for (const ref of idGroup.refs) {
                            result.push({
                                ref: ref,
                                value: values?.filter(it => it.key === ref.fieldName)[0].value as string
                            })
                        }
                    }
                }

                setRefData(result);
                setIsLoading(false);
            })();
        },
        [props.editor.dataOriginFeature.dataRefs, setRefData, props.editor.recipeSwitcher.activeRevision, props.editor.recipeSwitcher.activeCompany]);

    return (
        <div>
            <OriginTypeSection title="Dinamiche" data={refData}
                               isLoading={isLoading} editor={props.editor}
                               bottomButton={<Button className="w-full"
                                                     intent={Intent.PRIMARY}
                                                     disabled={!props.editor.mylabelAuthFeature.isConnected || !props.editor.recipeSwitcher.hasActiveCompany || !props.editor.recipeSwitcher.hasActiveRevision}
                                                     onClick={props.onLinkField}
                                                     icon="data-connection"
                               >
                                   Collega campo
                               </Button>}/>
        </div>
    );
});